import React from 'react'
import { Row, Col, Form, Radio, Transfer, Switch, Table, Tag, InputNumber } from 'antd'
import difference from 'lodash/difference'
import './index.less'

const FormItem = Form.Item

// Customize Table Transfer
const TableTransfer = ({
  preStateValues, leftColumns, rightColumns, ...restProps
}) => (
  <Transfer
    {...restProps}
    showSelectAll={false}
    locale={
      {
        itemUnit: 'шт.',
        itemsUnit: 'шт.',
        searchPlaceholder: 'Поиск',
        notFoundContent: 'Нет данных',
      }
    }
  >
    {({
      direction,
      filteredItems,
      onItemSelectAll,
      onItemSelect,
      selectedKeys: listSelectedKeys,
    }) => {
      const columns = direction === 'left' ? leftColumns : rightColumns

      preStateValues.length > 0 && filteredItems.map((item, key) => {
        filteredItems[key] = {
          ...filteredItems[key],
          discount: !!preStateValues[key] && preStateValues[key].discount,
}
      })

      const rowSelection = {
        // getCheckboxProps: item => ({ disabled: listDisabled || item.disabled }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows.map(({ key }) => key)
          const diffKeys = selected
            ? difference(treeSelectedKeys, listSelectedKeys)
            : difference(listSelectedKeys, treeSelectedKeys)
          onItemSelectAll(diffKeys, selected)
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected)
        },
        selectedRowKeys: listSelectedKeys,
      }

      return (
        <div>
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredItems}
            size='small'
          />
        </div>
      )
    }}
  </Transfer>
)

export default class ComboAction extends React.Component {
  constructor(props) {
    super(props)

    const preStateValues = []
    const preStateIdnums = []

    props.value.split(';').map((item, key) => {
      const _key = item.split(',')[0]
      const discount = item.split(',')[1] && Number(item.split(',')[1])
      const type = item.split(',')[2] && Number(item.split(',')[2])

      preStateIdnums[key] = _key

      preStateValues[key] = {
        key: _key,
        discount,
        type,
      }
    })

    this.handleChangeValues(preStateValues)

    this.state = {
      targetKeys: preStateIdnums,
      preStateValues,
    }

    this.setRightData = this.setRightData.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChangeValues = (values) => {
    const preValues = []
    values.map((item) => {
      Object.values(item).join(',') !== ',,' && preValues.push(Object.values(item).join(','))
    })

    this.props.onChange(preValues.join(';'))
  }

  handleChange = (nextTargetKeys) => {
    const preStateValues = []
    nextTargetKeys.map((item, key) => {
      const elem = this.state.preStateValues.find(o => o.key === item)

      preStateValues[key] = {
        key: item,
        discount: elem ? elem.discount : 0,
        type: elem ? elem.type : 0,
      }
    })

    this.setState({ preStateValues })
    this.setState({ targetKeys: nextTargetKeys })
    this.handleChangeValues(preStateValues)
  };

  setRightData = (type, e, row) => {
    const newValues = [...this.state.preStateValues]
    const index = this.state.preStateValues.findIndex(o => o.key === row.key)

    newValues[index] = {
      ...newValues[index],
      [type]: e,
    }

    this.setState({ preStateValues: newValues })
    this.handleChangeValues(newValues)
  };

  render() {
    const { getFieldDecorator } = this.props.form
    const { goods } = this.props
    const { targetKeys, preStateValues } = this.state

    const leftTableColumns = [
      {
        dataIndex: 'title',
        title: 'Название',
      },
      {
        dataIndex: 'type',
        title: 'Тип',
      },
    ]

    const rightTableColumns = [
      {
        dataIndex: 'title',
        title: 'Название',
      },
      {
        dataIndex: 'type',
        title: 'Тип',
      },
      {
        dataIndex: 'discount',
        title: 'Скидка',
        render: (discount, row) =>
          (<InputNumber
            onChange={e => this.setRightData('discount', e, row)}
            size='small'
            min={0}
            defaultValue={discount}
          />),
      },
    ]

    return (
      <div>
        <Row type='flex' justify='start' gutter={32}>
          <Col>
            <FormItem label='Подтип скидки' >
              {getFieldDecorator('f_action_subtypes', {
                initialValue: '1',
                rules: [{ required: true, message: 'Пожалуйта укажите подтип' }],
              })(<Radio.Group >
                <Radio.Button value='1'>Набор</Radio.Button>
                <Radio.Button value='2'>Товар</Radio.Button>
                <Radio.Button value='3'>Любой товар из выбранных</Radio.Button>
                 </Radio.Group>)}
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' justify='start' gutter={32}>
          <Col style={{ width: '100%' }}>
            <TableTransfer
              dataSource={goods}
              preStateValues={preStateValues}
              targetKeys={targetKeys}
              showSearch
              onChange={this.handleChange}
              filterOption={(inputValue, item) =>
                item.title && item.title.indexOf(inputValue) !== -1
              }
              leftColumns={leftTableColumns}
              rightColumns={rightTableColumns}
            />
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/containers/ActionForm/Combo.jsx